export default __webpack_public_path__ + "static/media/visa2.bdeee7c3.svg";